import { Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import { SampleScope } from '../../../../components/FrostedGate/SampleScope';
import { PageContainer } from '../../../../components/Layout/PageContainer';
import { getRouteTitle, ROUTES } from '../../../../constants/RouteNameMapping';
import { kpiCompanySeeds } from '../../kpi-sample-seeds';
import { useSampleKpiCompanies } from '../../useSampleKpiCompanies';
import { AllCompanies } from './AllCompanies';
import { AssignedCompanies } from './AssignedCompanies';
import { KPICompaniesTabs } from './KPICompaniesTabs';

interface KpiCompaniesPreviewProps {
  tab: 'all' | 'assigned';
}

/** The live KPI Companies page over a sample portfolio, while the module is frosted. */
export const KpiCompaniesPreview: FC<KpiCompaniesPreviewProps> = ({ tab }) => {
  const companies = useSampleKpiCompanies();
  const seeds = useMemo(() => kpiCompanySeeds(companies), [companies]);

  return (
    <SampleScope seeds={seeds}>
      <PageContainer>
        <Typography variant='h4'>{getRouteTitle(ROUTES.COMPANIES)}</Typography>
        <KPICompaniesTabs />
        {tab === 'assigned' ? <AssignedCompanies /> : <AllCompanies />}
      </PageContainer>
    </SampleScope>
  );
};
